import React from 'react';
import { Check } from '@mui/icons-material';
import { colors } from '@styles/colors';

const formatTimeAMPM = (timeStr) => {
  if (!timeStr) return '';
  // Check if it's already formatted
  const upper = timeStr.toUpperCase();
  if (upper.includes('A.M.') || upper.includes('P.M.') || upper.includes('AM') || upper.includes('PM')) {
    return timeStr;
  }
  
  const parts = timeStr.split(':');
  if (parts.length >= 2) {
    let hours = parseInt(parts[0], 10);
    const minutes = parts[1];
    
    if (!isNaN(hours)) {
      const ampm = hours >= 12 ? 'P.M.' : 'A.M.';
      hours = hours % 12;
      hours = hours ? hours : 12; // la hora 0 debe ser 12
      return `${hours}:${minutes} ${ampm}`;
    }
  }
  
  return timeStr;
};

// Componente CajaItems
function CajaItems({ titulo, texto, overlayMode = false }) {
  return (
    <div id="cajaItems" style={{
      width: overlayMode ? 'calc(100% - 3vh)' : '31.6vh',
      minHeight: '5.9vh',
      height: 'auto',
      position: 'relative',
      marginLeft: overlayMode ? '1.5vh' : '2.5vh',
      marginTop: '0.7vh',
      borderRadius: '0.6vh',
      backgroundColor: colors.white,
      opacity: 1,
      paddingBottom: '0.5vh'
    }}>
      {/* Div hijo dentro de cajaItems */}
      <div id="tituloItem" style={{
        width: overlayMode ? 'calc(100% - 2vh)' : '30.0vh',
        minHeight: '1.5vh',
        position: 'relative',
        top: '0.35vh',
        marginBottom: 0,
        opacity: 1,
      }}>
        <span style={{
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontSize: '1.5vh',
          lineHeight: '1.15',
          marginLeft: '1vh',
          letterSpacing: '0%',
          color: colors.gray600
        }}>
          {titulo}
        </span>
      </div>
      {/* Contenedor flex para círculo y texto en la misma línea */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginLeft: '0',
        width: '100%',
        paddingRight: '4vh'
      }}>
        {/* Texto primero */}
        <div id="textoItem" style={{
          width: overlayMode ? 'calc(100% - 5vh)' : '25vh',
          minHeight: '1.9vh',
          marginLeft: '1vh',
          marginTop: '0.65vh',
          marginBottom: '0.5vh',
          opacity: 1,
          display: 'flex',
          alignItems: 'center'
        }}>
          <span style={{
            fontFamily: 'Inter',
            fontWeight: 400,
            fontStyle: 'normal',
            fontSize: '1.7vh',
            lineHeight: '110%',
            color: colors.primaryText,
            letterSpacing: '0%',
            wordBreak: 'break-word'
          }}>
            {texto}
          </span>
        </div>
        {/* Círculo pegado al borde derecho del contenedor */}
        <div id="circulo" style={{
          width: '2.3vh',
          height: '2.3vh',
          backgroundColor: colors.primary,
          borderRadius: '50%',
          opacity: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          right: '1vh',
          top: '50%',
          transform: 'translateY(-50%)'
        }}>
          <Check style={{ color: colors.white, fontSize: '1.6vh' }} />
        </div>
      </div>
    </div>
  );
}

function CajaServicio({ titulo, texto, descripcion = '', overlayMode = false }) {
  return (
    <div id="cajaServicio" style={{
      width: overlayMode ? 'calc(100% - 3vh)' : '31.6vh',
      minHeight: '5.9vh',
      height: 'auto',
      position: 'relative',
      top: '2.0vh',
      marginLeft: overlayMode ? '1.5vh' : '2vh',
      borderRadius: '1vh',
      opacity: 1,
      paddingBottom: '2vh'
    }}>
      {/* Contenedor flex para círculo y texto en la misma línea */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginTop: '2vh',
        marginLeft: '0',
        width: '100%'
      }}>
        {/* Texto primero */}
        {/* Círculo pegado al borde derecho del contenedor */}
        <div id="circuloSer" style={{
          width: '3.3vh',
          height: '3.3vh',
          backgroundColor: colors.primary,
          borderRadius: '50%',
          opacity: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Check style={{ color: colors.white, fontSize: '1.6vh' }} />
        </div>
        <div id="textoItemSer" style={{
          width: overlayMode ? 'calc(100% - 5vh)' : '30vh',
          height: '1.9vh',
          marginLeft: '1',
          opacity: 1,
          display: 'flex',
          alignItems: 'center'
        }}>
          <span style={{
            fontFamily: 'Inter',
            fontWeight: 400,
            fontStyle: 'normal',
            marginTop: '1.3vh',
            marginLeft: '1vh',
            fontSize: '1.7vh',
            lineHeight: '100%',
            color: colors.primaryText,
            letterSpacing: '0%'
          }}>
            {texto}
          </span>
        </div>
      </div>
      <br />
      <div id="descripItemSer" style={{
        width: overlayMode ? 'calc(100% - 3vh)' : '30vh',
        minHeight: '1.9vh',
        height: 'auto',
        marginTop: '0.2vh',
        marginLeft: '2vh',
        opacity: 1,
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '2vh'
      }}>
        <span style={{
          fontFamily: 'Inter',
          fontWeight: 400,
          fontStyle: 'normal',
          marginLeft: '1vh',
          fontSize: '1.5vh',
          lineHeight: '120%',
          color: colors.primaryText,
          letterSpacing: '0%',
          wordBreak: 'break-word',
          display: 'block'
        }}>
          {descripcion || ''}
        </span>
      </div>


    </div>
  );
}

function Resumen({ ciudad, servicio, ubicacion, fecha, medico, hora, nomServicio, descripcion = '', variant = 'sidebar' }) {
  const overlayMode = variant === 'overlay';
  const outerStyle = overlayMode
    ? {
        width: '100%',
        maxWidth: 'min(40vh, 92vw)',
        height: 'auto',
        maxHeight: '78vh',
        overflowY: 'auto',
        borderRadius: '1.5vh',
        backgroundColor: colors.resumenBg,
        margin: 0,
        opacity: 1,
        boxSizing: 'border-box',
        paddingBottom: '2vh',
      }
    : {
        width: '36.7vh',
        height: '69vh',
        borderRadius: '1.5vh',
        backgroundColor: colors.resumenBg,
        marginLeft: '17vh',
        marginTop: '-14vh',
        opacity: 1,
      };

  return (
    <div id="cajaResumen" style={outerStyle}>
      {/* Div con título "Resumen de visita" */}
      <div id="tituloResumen" style={{
        width: '100%',
        height: '2.4vh',
        top: '1vh',
        marginTop: '2vh',
        opacity: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
      }}>
        <span style={{
          fontFamily: 'Inter',
          fontWeight: 700,
          fontStyle: 'normal',
          fontSize: '2.0vh',
          lineHeight: '100%',
          marginTop: '1vh',
          letterSpacing: '0%',
          color: colors.primaryText
        }}>
          Resumen de agendamiento 
        </span>
      </div>
      <br /><br />
      {/* Componente CajaItems */}
      <CajaItems titulo="Ubicación" texto={ciudad} overlayMode={overlayMode} />
      {servicio && <CajaItems titulo="Servicio" texto={servicio} overlayMode={overlayMode} />}
      {ubicacion && <CajaItems titulo="Sede" texto={ubicacion} overlayMode={overlayMode} />}
      {fecha && <CajaItems titulo="Fecha" texto={fecha} overlayMode={overlayMode} />}
      {medico && <CajaItems titulo="Profesional" texto={medico} overlayMode={overlayMode} />}
      {hora && <CajaItems titulo="Horario" texto={formatTimeAMPM(hora)} overlayMode={overlayMode} />}
      {nomServicio && <CajaServicio titulo="" texto={nomServicio} descripcion={descripcion} overlayMode={overlayMode} />}


    </div>
  );
}

export default Resumen;